{
  "overview": {
    "no_clusters": "This project does not have any clusters yet. Create one using the Create button in the top right!",
    "table": {
      "instances": "Instances",
      "tooltips": {
        "details": "Details",
        "clone": "Clone (Not yet implemented)",
        "delete": "Delete",
        "namespace": "The Kubernetes namespace in which this service is deployed.",
        "supportPlan": "The type of support available for this service, based on your plan.",
        "instances": "The number of active instances running for this service.",
        "status": "The status reflects the health and availability of this service."
      }
    },
    "modals": {
      "delete": {
        "title": "Delete cluster",
        "content_text": "Are you sure that you want to delete this cluster? This cannot be undone."
      }
    }
  },
  "details": {
    "new_information_applied": "New Information has been applied",
    "could_not_retrieve_cluster_data": "Something went wrong. The cluster information could not be retrieved.",
    "header": {
      "replica": "Nodes",
      "desired_replica": "{{count}} Desired",
      "storage": "Storage",
      "storage_used": "Used Storage",
      "cluster_is_creating": "The cluster is currently being created.",
      "cluster_is_updating": "The cluster is currently being updated.",
      "cluster_is_unavailable": "The cluster is currently unavailable.",
      "this_may_take_a_few_minutes": "This may take up to a few minutes.",
      "upgrade_tooltip": "Upgrade to the next version",
      "upgrade_in_progress_tooltip": "Upgrade in progress",
      "upgrade_scheduled_tooltip": "Upgrade already scheduled",
      "create_from_backup": "Create from backup",
      "restore_from_backup": "Restore from backup",
      "name": {
        "move": "Move to another project",
        "save": "Save",
        "cancel": "Cancel",
        "submit": "Submit changes"
      },
      "favorite": {
        "add": "Add to favorites",
        "remove": "Remove from favorites"
      },
      "delete": "Delete",
      "delete_disable_reason": {
        "being_cloned_already": "This cluster is currently being cloned and can not be deleted."
      },
      "manage": "Manage",
      "backups_not_available": "Continuous backups are disabled. Restore from backup is not possible",
      "backups_scheduled": "Backups are not available but scheduled",
      "backups_available": "Create cluster from backup",
      "move_not_available": "The cluster can not be moved during creation",
      "redirect_now": "Redirect me now",
      "edit_form": {
        "title": "Edit Cluster",
        "name": "Name",
        "description": "Description",
        "project": "Project"
      },
      "raiseTicket": "Raise Ticket",
      "upgrade_version_form": {
        "title": "Upgrading to PostgreSQL {{version}}",
        "warning_no_backup": "<b>No backups were found for this cluster.</b>",
        "warning_latest_backup": "<b>The latest cluster backup was completed on {{dateTime}}</b>",
        "warning_message": "Before proceeding with the upgrade, please ensure a recent full cluster backup is available.",
        "confirm_message": "You are attempting to proceed with the upgrade outside of the defined maintenance window. If you proceed, it will be automatically scheduled to run during the next maintenance window <b>{{maintenanceWindows}} UTC</b>.",
        "confirm_question": "Do you want to continue with the upgrade?",
        "submit": "Upgrade"
      },
      "restore_form": {
        "title": "Restore Cluster",
        "tooltip": "Provide a backup timestamp or select one from the list of available backups",
        "backup_label": "Select backup",
        "backup_tooltip": "If a backup is selected, its timestamp will be used",
        "show_more_options": "Show more backups",
        "show_less_options": "Show less backups",
        "warning_message": "Restoring the cluster from a backup will overwrite existing data. Any changes made after the backup was created will be lost.",
        "restore_button": "Restore"
      }
    },
    "summary": {
      "title": "Overview",
      "copy": "Copy",
      "copied": "Copied!",
      "show": "Show",
      "hide": "Hide"
    },
    "parameters": {
      "title": "Parameters",
      "field_menu": {
        "copy_prop_name": "Copy name",
        "copy_prop_value": "Copy value"
      },
      "warning": {
        "postmaster_warn": "Changing this setting will restart the database.",
        "sync_failed": "This value is still being updated. Current value: {{value}}"
      },
      "collapse_titles": {
        "general": "General",
        "optimizerSettings": "Optimizer settings",
        "logfiles": "Logfiles",
        "statsCollection": "Statistics collection",
        "autovacuum": "Autovacuum",
        "miscellaneous": "Miscellaneous"
      },
      "errors": {
        "maximum": "Should be <= {{limit}}",
        "minimum": "Should be >= {{limit}}",
        "multipleOf": "Should be multiple of {{multipleOf}}",
        "type": {
          "number": "Should be a number",
          "integer": "Should be an integer"
        }
      }
    },
    "replicas": {
      "title": "Nodes",
      "instance": "Instance",
      "role": "role",
      "lag": "Lag",
      "status": "status",
      "storage_usage": "{{used}} ({{usedPercent}}%) / {{initial}}",
      "logs": "Logs",
      "actions": "Actions",
      "roles": {
        "replica": "Replica",
        "primary": "Primary",
        "pending": "Pending"
      },
      "download": {
        "title": "Enter the maximum age of the log entries",
        "form": {
          "time": "Time",
          "units": {
            "sec": "Seconds",
            "min": "Minutes",
            "hour": "Hours"
          },
          "buttons": {
            "cancel": "Cancel",
            "submit": "Download"
          }
        }
      },
      "add_replica": {
        "title": "Add replica",
        "confirm": "Are you sure you want to add a replica to the cluster?"
      },
      "restart": {
        "title": "Are you sure that you want to restart instance {{instanceId}} ({{instanceRole}})? This will drop all open connections.",
        "cancel_button_label": "Cancel"
      },
      "download_tooltip": "Download logs",
      "show_logs_tooltip": "Show logs",
      "hide_logs_tooltip": "Hide logs",
      "restart_tooltip": "Restart node",
      "restart_tooltip_disabled": "The node can only be restarted if both itself and the cluster are Running"
    },
    "load_balancing": {
      "title": "Load Balancing",
      "master_load_balancing": "Master Load Balancing",
      "replica_load_balancing": "Replica Load Balancing"
    },
    "backups": {
      "size_history_title": "Backups size history",
      "no_size_history": "No backups are available for the selected period, or there is not enough data to display the backup histogram",
      "title": "Backups",
      "backup_now": "Create Backup",
      "backup_now_in_progress": "Your backup is being created. It may take a few minutes to appear in the list.",
      "backup_now_terminating": "Cancelling backup",
      "backup_now_cancel": "Cancel backup",
      "backup_schedule": "Enable logical backups",
      "your_local_time": "Local Time",
      "server_time": "Server Time",
      "table": {
        "name": "Name",
        "date": "Date",
        "size": "File size",
        "actions": {
          "download": "Download"
        }
      },
      "logical": "Logical",
      "continuous": "Continuous",
      "backups_time": "Backup time",
      "cycle": "Cycle",
      "next_backup_scheduled": "Next backup scheduled",
      "next_logical_backup_scheduled": "Next logical backup scheduled",
      "next_continuous_backup_scheduled": "Next continuous backup scheduled",
      "backups_list": "Backups List",
      "continuous_backups_tab_title": "Enable continuous backups",
      "retention_period": "Retention period",
      "retention_period_not_valid": "Must be a number from 2 to 60",
      "oldest_possible_restore_point": "Oldest possible restore point",
      "no_backups_scheduled": "No backups scheduled",
      "days": "days",
      "backup_size": "Total backup size: {{currentSize}}",
      "base_backup_size": "Total base backup size: {{currentBaseSize}}",
      "delete_all_backups": "Delete all",
      "want_delete_backup": "Are you sure that you want to delete {{name}} backup? This cannot be undone.",
      "want_delete_all_backups": "Are you sure that you want to delete all backups? This cannot be undone.",
      "want_to_cancel_backup_now": "Are you sure that you want to cancel the currently creating backup?",
      "no_base_backup": "No base backup has been created yet.",
      "confirm_disable_continuous_backups": "Disabling continuous backups will result in the unrecoverable loss of all base-backups and wal files. Are you sure that you want to continue?",
      "no_backups": "There are currently no backups"
    },
    "storage": {
      "title": "Storage usage",
      "used": "Used",
      "usage": "Usage",
      "available": "Available",
      "error": {
        "title": "Storage information currently unavailable",
        "annotation": "You may still see the storage consumption of each individual <nodeLink>node</nodeLink>"
      }
    },
    "acl": {
      "title": "ACL",
      "firewall": {
        "title": "Firewall Settings",
        "max_limit": "You’ve reached the maximum number of allowed IP addresses",
        "warning": "By default, the allowed source range is 0.0.0.0/32 (no inbound access). Update this setting to your IP (e.g., 204.0.93.5/32) to access the cluster externally.",
        "form": {
          "allowed_source_ranges": "Allowed source ranges",
          "hint": "Specify the network ranges in CIDR notation (e.g. <b>192.168.0.1/32</b>) that should be allowed to access this service. Only traffic from these sources will be permitted",
          "ip_address": "IP Address",
          "actions": {
            "remove": "Remove IP Address",
            "add": "Add IP Address"
          }
        }
      },
      "pg_hba": {
        "title": "PG HBA"
      },
      "connection_type": "Connection Type",
      "database": "Database",
      "user": "user",
      "address": "address",
      "auth_method": "Auth Method",
      "no_acl_rules_warning": "Warning! You won’t be able to connect anymore if all ACL rules are deleted!",
      "validation": {
        "type": {
          "empty": "Type is required"
        },
        "database": {
          "empty": "Database is required",
          "not_valid": "Double quotes are not allowed"
        },
        "user": {
          "empty": "User is required",
          "not_valid": "Double quotes are not allowed"
        },
        "address": {
          "empty": "Address is required",
          "not_valid": "Invalid address"
        }
      }
    },
    "current_replicas": "Current replicas",
    "desired_replicas": "Desired replicas",
    "datasets": {
      "title": "Datasets",
      "no_datasets": "There are no datasets yet",
      "table": {
        "name": "Name",
        "import_date": "Import date",
        "status": "Status",
        "schema": "Schema",
        "category": "Category",
        "import_type": "Import type",
        "database": "Database",
        "dataset": "Dataset",
        "permission": "Permissions",
        "actions": "Actions",
        "operation_type": "Type",
        "result": "Result",
        "import_start": "Import Start",
        "import_end": "Import End"
      },
      "import": "Import Dataset",
      "dataset": {
        "import_status": {
          "idle": "Idle",
          "pending": "Pending",
          "importing": "Importing",
          "aborting": "Aborting",
          "idle_present": "Available",
          "idle_not_present": "Missing"
        },
        "status": {
          "pending": "Pending",
          "importing": "Importing",
          "successful": "Successful",
          "aborted": "Aborted",
          "failure": "Failure",
          "idle": "Idle",
          "error": "Failure",
          "credentials_invalid": "Invalid Credentials",
          "database_not_found": "Database missing",
          "schema_exists": "Schema conflict",
          "insufficient_space": "Insufficient space"
        },
        "import_type": {
          "readonly": "Readonly",
          "not_readonly": "Editable"
        },
        "operation_type": {
          "import": "Import",
          "editable": "Owner change"
        },
        "no_imports_in_database": "This database does not have any imported datasets.",
        "cancel": "Cancel",
        "reimport": "Re-import",
        "delete": "Delete",
        "action_disable_reason": {
          "schema_conflict": "Another schema with the same name already exists and thus can not be re-imported.",
          "reimport_drop_schema_first": "To prevent unwanted data-loss, re-importing editable datasets is not allowed. Please ensure that you no longer need it and then drop it manually instead.",
          "delete_drop_schema_first": "To prevent unwanted data-loss, deleting editable datasets is not allowed. Please ensure that you no longer need it and then drop it manually instead."
        },
        "set_not_readonly": "Make editable",
        "delete_confirm_message": "Are you sure that you want to delete the dataset {{datasetName}}? Since it is it missing in the database, this will only delete the import history.",
        "cancel_confirm_message": "Are you sure that you want to abort the import of the dataset {{dataset_name}}?",
        "reimport_confirm_message": "Are you sure that you want to re-import the dataset {{dataset_name}}? This will purge all references to this schema.",
        "set_not_readonly_confirm_message": "Are you sure that you want to make dataset {{dataset_name}} editable?"
      },
      "overlay": {
        "title": "Import Datasets",
        "buttons": {
          "import": "Import",
          "cancel": "Cancel"
        }
      }
    },
    "members": {
      "title": "Members",
      "list": {
        "title": "Members",
        "you": "You",
        "no_members": "There are not members",
        "form": {
          "empty_list": "Member list is empty",
          "search": {
            "no_results": "Nothing was found"
          }
        }
      }
    },
    "application": {
      "title": "Application",
      "open_in_new_tab": "Open application in a new tab"
    },
    "lifecycle_state": {
      "stop_confirm_message": "Are you sure that you want to stop this service?",
      "start_confirm_message": "Are you sure that you want to start this service?",
      "stop_tooltip": "Stop service",
      "start_tooltip": "Start service"
    }
  },
  "price_estimation": {
    "instance": "Instance",
    "replicas": "Replicas",
    "cores": "CPU",
    "memory": "Memory",
    "storage": "Storage",
    "specs": {
      "cores": "{{count}} Core",
      "cores_plural": "{{count}} Cores",
      "memory_gb": "{{count}} GB",
      "storage_gb": "{{count}} GB"
    },
    "support_plan": {
      "title": "Support plan",
      "name": "Name",
      "description": "Description"
    },
    "periods": {
      "per_month": "per month",
      "per_day": "per day"
    },
    "total": "Total"
  },
  "create": {
    "cluster_created": "The cluster has been successfully created",
    "stepper": {
      "general": "General",
      "plan": "Plan",
      "summary": "Summary"
    },
    "selector": {
      "submit_button": {
        "pending": "Select a service",
        "loading": "Validating...",
        "pass": "Next",
        "fail": "Unsuitable service"
      },
      "tooltips": {
        "unsuitable_service_type": "Unsuitable service type.",
        "continuous_backups_not_enabled": "Continuous backups are disabled on this service.",
        "no_oldest_restore_point": "The service does not have any base backups yet.",
        "service_is_creating": "The service is still being created.",
        "failed_to_get_service_state": "There has been an error while retrieving the services state."
      }
    },
    "form": {
      "allow_all_connections": "Allow all connections"
    },
    "plan": {
      "hour": "Hour",
      "gbs": "{{count}} GB",
      "cpu": "Cores",
      "choose_compute_plan": "Choose a compute plan",
      "choose_storage_plan": "Choose a storage plan"
    },
    "summary": {
      "title": "Price per month",
      "compute_plan_name": "Type",
      "price_per_instance": "Per instance",
      "replicas": "Replicas",
      "total": "Total"
    }
  },
  "plan": {
    "change_plan": "Change plan",
    "submit": "Submit",
    "cancel": "Cancel",
    "title": "Plan",
    "current": "Current",
    "deprecated": "Current (Deprecated)",
    "disable_reasons": {
      "tiny": "Plan too tiny",
      "large": "Plan too large",
      "storage": {
        "different": "Different storage type",
        "tiny_and_different": "Plan too tiny and of different storage type"
      }
    },
    "pgConfig": {
      "title": "Suggested PostgreSQL parameters",
      "noSuggestions": "There are no new suggestions for your chosen resource allocation.",
      "unchangedWarning": "If left unchanged, this parameter will exceed the suggested bounds of this setting."
    }
  },
  "advice": {
    "title": "Advice",
    "severitySummary": {
      "NOTICE": "Your database health is <1>excellent</1>.<br/>No immediate action is required, though insights are available.",
      "REMARK": "Your database health is generally <1>good</1>, with a few minor recommendations detected.",
      "LOW": "Your database is <1>stable</1>, but optimizations are suggested to improve performance or security.",
      "MEDIUM": "Your database health shows <1>moderate</1> issues.<br/>We recommend reviewing and applying the suggestions.",
      "HIGH": "Your database is experiencing <1>high-impact</1> issues.<br/>Immediate attention is advised.",
      "SHOWSTOPPER": "Your current database health is regarded as <1>critical</1>.<br/>We recommend urgent action based on the recommendations from Scalefields Deep Thinker."
    },
    "labels": {
      "createdAt": "Detected",
      "type": "Module",
      "object": "Object",
      "subobject": "Subobject",
      "info": "Summary",
      "text": "Reason",
      "detail": "Detail",
      "script": "Script",
      "furtherReading": "Further Reading"
    },
    "table": {
      "noAdvice": "No issues detected. Your database is in great shape!",
      "actions": "Actions",
      "dismiss": "Hide advice"
    },
    "info": {
      "title": "Advice Details",
      "scriptAvailable": "Auto Fix",
      "scriptAvailableTooltip": "This issue can be auto-resolved with the provided script.",
      "furtherReadingAvailable": "Learn More",
      "furtherReadingAvailableTooltip": "External resource for further reading available.",
      "cancelButton": "Close"
    },
    "modules": {
      "MODULE_BLOAT": "Bloat",
      "MODULE_COLLECT_STATS": "Collect Stats",
      "MODULE_CONFIG": "Configuration",
      "MODULE_INDEX_ANOMALIES": "Index Anomalies",
      "MODULE_RUNTIME": "Runtime",
      "MODULE_SAMPLE": "Sample",
      "MODULE_SECURITY": "Security",
      "MODULE_STORAGE": "Storage",
      "MODULE_TABLE_ANOMALIES": "Table Anomalies",
      "MODULE_VARIOUS": "Various"
    },
    "severities": {
      "NOTICE": "Notice",
      "REMARK": "Remark",
      "LOW": "Low",
      "MEDIUM": "Medium",
      "HIGH": "High",
      "SHOWSTOPPER": "Critical"
    },
    "status": {
      "running": "RUNNING",
      "succeeded": "SUCCESS",
      "failed": "FAILED",
      "unknown": "UNKNOWN"
    },
    "rerun_check": "Rerun check",
    "confirm_rerun_check": "Are you sure you want to start a database check?",
    "last_check": "Last check: <1>{{datetime}}</1>",
    "not_found": "not found",
    "ignored_advice": "You have one hidden advice item.",
    "ignored_advice_plural": "You have {{count}} hidden advice items.",
    "undo_ignored_advice": "Restore all"
  },
  "instance": "{{count}} instance",
  "instance_plural": "{{count}} instances",
  "search": "Search",
  "type": "Type",
  "status": "Status",
  "name": "Name",
  "description": "Description",
  "generate_new": "Generate new",
  "create_new": "Create new",
  "apply": "Apply",
  "reset": "Reset",
  "submit": "Submit",
  "master": "Primary",
  "babelfish": "Babelfish",
  "load_balancer_for_replicas": "Load balancer for replicas",
  "utc": "UTC",
  "cluster_filter_no_data": "There are no clusters that match the filters you've applied.",
  "no_clusters": "This project does not have any clusters yet.",
  "loading_please_wait": "The cluster is being initialized.<br/>This may take a few minutes, please be patient...",
  "dynamically_allocated": "Dynamically allocated",
  "enter_fullscreen_tooltip": "Enter fullscreen mode",
  "exit_fullscreen_tooltip": "Exit fullscreen mode"
}
